import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { track, isTouchScreen } from '@client/helpers';
import { buildCampaignUrl } from '@client/helpers/campaignUrl';
import { XMAS_EVENT_DELIVERY_PROMISE } from '@client/config/constants';
import CampaignOverlay from './CampaignOverlay';
import CampaignLabel from './CampaignLabel';

import { getSelectedFilter } from '@client/redux/modules/mylounge-legacy/selectors';
import { getTrackingData } from '@client/redux/modules/tracking/selectors';

import styles from './openCampaign.scss';

export class OpenCampaign extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isHovering: false,
        };
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
    }

    render() {
        const {
            campaign,
            dimension,
            campaignStyles,
            showDelivery,
            filterTag,
        } = this.props;
        const { isHovering } = this.state;
        const campaignId = `campaign-${campaign.campaignIdentifier}`;

        const destination = buildCampaignUrl(
            campaign.campaignIdentifier,
            filterTag,
        );
        const withDeliveryLabel =
            showDelivery ||
            (campaign.options &&
                (campaign.options.shortenDelivery ||
                    campaign.options.deliveryPromiseType));
        const coverWithoutLogo = !campaign.hasLogo;

        return (
            <a
                href={destination}
                id={campaignId}
                styleName={classnames('wrapper', {
                    'without-logo': coverWithoutLogo,
                })}
                style={campaignStyles}
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
                onClick={this.trackingFunc}
            >
                <div styleName="inner-wrapper">
                    <CampaignOverlay
                        name={campaign.name}
                        bannerText={campaign.bannerText}
                        dimension={dimension}
                        hover={isHovering}
                    />
                    <CampaignLabel
                        discount={campaign.discount.value}
                        dimension={dimension}
                        hover={isHovering}
                        campaign={campaign}
                        showDelivery={showDelivery}
                    />
                    {coverWithoutLogo && (
                        <div
                            styleName={classnames('title-label', {
                                'with-delivery': withDeliveryLabel,
                                [`dimension-${dimension}`]: dimension,
                            })}
                        >
                            {campaign.name}
                        </div>
                    )}
                </div>
            </a>
        );
    }

    trackingFunc = () => {
        const { campaign, position, filterTag, tracking } = this.props;

        track('campaignOverview_campaign_click', {
            productCampaign: campaign.campaignIdentifier,
            positionNumber: position,
            campaign_level_1: campaign.name,
            campaign_level_2: filterTag,
            ...(campaign.options && campaign.options.deliveryPromiseType === XMAS_EVENT_DELIVERY_PROMISE && { component: 'christmas' }),
            visitorID: tracking ? tracking.visitorID : null,
        });
    };

    handleMouseOver() {
        this.setState({ isHovering: !isTouchScreen() && true });
    }

    handleMouseOut() {
        this.setState({ isHovering: false });
    }
}

OpenCampaign.propTypes = {
    campaign: PropTypes.object.isRequired,
    dimension: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    campaignStyles: PropTypes.object,
    showDelivery: PropTypes.bool,
    filterTag: PropTypes.string,
    tracking: PropTypes.object
};

const mapStateToProps = state => ({
    filterTag: getSelectedFilter(state),
    tracking: getTrackingData(state)
});

export default compose(
    connect(mapStateToProps),
    CSSModules(styles, { allowMultiple: true }),
)(OpenCampaign);
